import React from 'react';

import { createClassName } from 'utils/createClassName';

import './labelStyles.scss';

type Props = {
  idFor?: string;
};

export const LabelComponent: React.FC<Props> = (props) => {
  const { children, idFor } = props;

  const className = createClassName('label')();

  return (
    <label className={className} htmlFor={idFor}>
      {children}
    </label>
  );
};
